import { render, staticRenderFns } from "./home-statistics-small.vue?vue&type=template&id=bc62d956&"
import script from "./home-statistics-small.vue?vue&type=script&lang=ts&"
export * from "./home-statistics-small.vue?vue&type=script&lang=ts&"
import style0 from "./home-statistics-small.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports